import { render, staticRenderFns } from "./ViewSchemePlanPropertiesTable.vue?vue&type=template&id=878123b4"
import script from "./ViewSchemePlanPropertiesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewSchemePlanPropertiesTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports